import { NavbarType } from "_interfaces";
import { API_ENDPOINT } from "_lib/utils";
import axios from "axios";
import { atom, selector } from "recoil";

const NavbarSelector = selector<NavbarType[]>({
  key: "NavbarSelector",
  get: async ({ get }) => {
    try {
      const res = await axios.get(
        `${API_ENDPOINT}/items/navbar`
      );
      const data: NavbarType[] = res.data.data.map((d: any) => {
        return {
          text: d.text,
          link: d.link,
        };
      });
      return data;
    } catch (error) {
      console.error(error);
      return [] as NavbarType[];
    }
  },
});

const NavbarAtom = atom<NavbarType[]>({
  key: "NavbarAtom",
  default: NavbarSelector,
});

export { NavbarAtom };
